import { render, staticRenderFns } from "./ContactsCreate.vue?vue&type=template&id=36f0417b&scoped=true"
import script from "./ContactsCreate.vue?vue&type=script&lang=js"
export * from "./ContactsCreate.vue?vue&type=script&lang=js"
import style0 from "./ContactsCreate.vue?vue&type=style&index=0&id=36f0417b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0417b",
  null
  
)

export default component.exports